import AppHeader from '../AppHeader'

//
// 入社手続き 確認・承認画面（F-NEW-05 / 06 / 07 / 11）
//
export default {
  name: 'onboarding-detail',
  created () {
    if (!this.canReview) {
      this.$router.push({ path: '/' })
      return
    }
    this.search()
  },
  data () {
    return {
      searchCallbackFlag: false,
      employmentPattern: 'full_time',
      reviewComments: {},
      openedHistories: {},
      // 本人情報パネル（訂正）
      profileEditing: false,
      profileSaving: false,
      profileForm: {},
      // パートの通知書に印字するシフト区分（仮登録で選んだもの。ここで変えて通知書を作り直せる）
      contractShiftClassIds: [],
      // 【本登録】の送信中
      registering: false
    }
  },
  computed: {
    user () {
      return this.$store.getters.onboardingUser
    },
    documents () {
      return this.$store.getters.onboardingDocuments || []
    },
    contract () {
      return this.$store.getters.onboardingContract
    },
    myNumber () {
      return this.$store.getters.myNumber
    },
    notify () {
      return this.$store.getters.onboardingNotify
    },
    forbidden () {
      return this.$store.getters.onboardingForbidden
    },
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isAppIncluding () {
      return this.$store.getters.isAppIncluding
    },
    isAppNotIncluded () {
      return this.$store.getters.isAppNotIncluded
    },
    isShopMaster () {
      return this.$store.getters.shopMaster
    },
    isClerk () {
      return this.$store.getters.clerk
    },
    isHumanStaff () {
      return window.localStorage.getItem('is_human_staff') === '1'
    },
    isHrManager () {
      return window.localStorage.getItem('user_authority') === '5' || this.isSystemManagement
    },
    // 権限区分2・3、店舗管理者・事務員は自店、総務系は全店（API の authorized_reviewer_for? と同じ）
    canReview () {
      return this.isAppIncluding || this.isAppNotIncluded || this.isShopMaster || this.isClerk ||
        this.isHumanStaff || this.isHrManager || this.isSystemManagement
    },
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    // パートの通知書に印字する配属店舗のシフト区分（休暇系を除く）
    shiftClasses () {
      return this.$store.getters.onboardingShiftClasses || []
    },
    isPartPattern () {
      return this.employmentPattern === 'part_free' || this.employmentPattern === 'part_80'
    },
    // 入社手続きが完了（本登録済み）か。完了後は【本登録】を出さない
    isCompleted () {
      return !!this.user && this.user.onboarding_status === 'onboarding_completed'
    },
    // 【本登録】の事前チェック結果（API の register_checks: ready / can_force / items）
    registerChecks () {
      return this.$store.getters.onboardingRegisterChecks
    },
    // すべての項目を満たしている（本登録できる）
    registerReady () {
      return !!this.registerChecks && this.registerChecks.ready === true
    },
    // 不足があっても強制登録（force: true）できる権限（人事管理責任者・システム管理者。API が判定した値を使う）
    canForceRegister () {
      return !!this.registerChecks && this.registerChecks.can_force === true
    },
    // 【本登録】ボタンを押せるか（満たしているか、強制登録できる権限か）
    canPressRegister () {
      return this.registerReady || this.canForceRegister
    },
    // 本人情報パネルに表示する項目（ラベルキー・列・入力種別。readonly は表示のみ）
    profileFields () {
      return [
        {key: 'user_name', type: 'text'},
        {key: 'user_firstname', type: 'text'},
        {key: 'user_name_furigana', type: 'text'},
        {key: 'user_firstname_furigana', type: 'text'},
        {key: 'user_birthday', type: 'date'},
        {key: 'user_sex', type: 'sex'},
        {key: 'user_post_no', type: 'text'},
        {key: 'user_address', type: 'text'},
        {key: 'user_mobile', type: 'text'},
        // 入社経緯（本人が入力。社員編集画面と同じ joins マスタ）
        {key: 'join_class', type: 'readonly'},
        {key: 'emergency_contact_name', type: 'text'},
        {key: 'emergency_contact_relation', type: 'text'},
        // 緊急連絡先の電話番号は社員編集と同じ電話番号入力（ハイフン区切り、または数字のみ10桁・11桁）
        {key: 'emergency_contact_tel', type: 'tel'},
        {key: 'emergency_contact2_name', type: 'text'},
        {key: 'emergency_contact2_relation', type: 'text'},
        {key: 'emergency_contact2_tel', type: 'tel'},
        {key: 'bank_name', type: 'text'},
        {key: 'bank_branch_name', type: 'text'},
        {key: 'bank_account_type', type: 'account_type'},
        {key: 'bank_account_holder', type: 'text'},
        // 通勤手段・配偶者・扶養・兼業・職歴・備考（r643 / r665-682。総務用名簿に印字する。本人と同じ列を訂正できる）
        {key: 'commute_method', type: 'commute'},
        {key: 'commute_public_detail', type: 'text'},
        {key: 'is_dormitory', type: 'flag'},
        {key: 'has_spouse', type: 'yes_no'},
        {key: 'has_dependents', type: 'yes_no'},
        {key: 'dependents_count', type: 'number'},
        {key: 'has_side_job', type: 'yes_no'},
        {key: 'side_job_started_on', type: 'month'},
        {key: 'work_history1_from', type: 'month'},
        {key: 'work_history1_to', type: 'month'},
        {key: 'work_history1_content', type: 'text'},
        {key: 'work_history2_from', type: 'month'},
        {key: 'work_history2_to', type: 'month'},
        {key: 'work_history2_content', type: 'text'},
        {key: 'work_history3_from', type: 'month'},
        {key: 'work_history3_to', type: 'month'},
        {key: 'work_history3_content', type: 'text'},
        {key: 'profile_remarks', type: 'text'},
        // 「上記の内容に相違がないことを確認しました」は本人の確認なので店舗では変えない（表示のみ）
        {key: 'profile_confirmed_at_format', type: 'readonly'}
      ]
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function () {
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
        if (self.contract) {
          self.employmentPattern = self.contract.employment_pattern
        } else if (self.user && self.user.employment_pattern) {
          self.employmentPattern = self.user.employment_pattern
        }
        self.contractShiftClassIds = (self.user && self.user.contract_shift_class_ids) ? self.user.contract_shift_class_ids.slice() : []
        self.profileEditing = false
        if (self.user && self.user.shop_id) {
          self.$store.dispatch('GET_ONBOARDING_SHIFT_CLASSES', {data: {shop_id: self.user.shop_id}})
        }
      }
      this.$store.dispatch('GET_ONBOARDING_USER', {id: this.$route.params.id, callback: callback})
    },
    // 本人情報の表示値（性別・口座種別・通勤手段・有無は名称に、未設定は「-」）
    profileValue: function (field) {
      var value = this.user ? this.user[field.key] : null
      if (field.type === 'sex') {
        return value === 1 ? this.$t('onboarding.profile.sex_male') : (value === 2 ? this.$t('onboarding.profile.sex_female') : '-')
      }
      if (field.type === 'account_type') {
        return value === 1 ? this.$t('onboarding.profile.account_ordinary') : (value === 2 ? this.$t('onboarding.profile.account_current') : '-')
      }
      if (field.type === 'commute') {
        return value ? this.$t('onboarding.profile.commute_' + value) : '-'
      }
      if (field.type === 'yes_no') {
        return value === 1 ? this.$t('onboarding.profile.yes') : (value === 0 ? this.$t('onboarding.profile.no') : '-')
      }
      if (field.type === 'flag') {
        return value === 1 ? this.$t('onboarding.profile.yes') : this.$t('onboarding.profile.no')
      }
      return (value === null || value === undefined || value === '') ? '-' : value
    },
    // 年月（YYYY-MM）の形式。空欄は通す（API も同じ形式で判定する）
    isMonthValid: function (key) {
      var value = this.profileForm[key]
      return !value || /^\d{4}[-/]\d{1,2}$/.test(value)
    },
    startProfileEdit: function () {
      var form = {}
      for (var i = 0; i < this.profileFields.length; i++) {
        // 表示のみの項目（入社経緯）は訂正の対象にしない
        if (this.profileFields[i].type === 'readonly') {
          continue
        }
        var key = this.profileFields[i].key
        var value = this.user[key]
        form[key] = (value === null || value === undefined) ? '' : String(value)
      }
      this.profileForm = form
      this.profileEditing = true
    },
    cancelProfileEdit: function () {
      this.profileEditing = false
    },
    // 電話番号の形式（社員編集と同じ 0X-XXXX-XXXX、または数字のみ10桁・11桁。API の normalize_tel と同じ扱いで、
    // 11桁は API が 3-4-4 に揃え、10桁（固定電話）はハイフン無しのまま保存される）。
    // 空欄と、保存済みの値を変えていないときは通す
    // （形式チェックを後から足したため、形式外の保存済みの値があっても他の項目の訂正を妨げない。API も同じ扱い）
    isTelValid: function (key) {
      var value = this.profileForm[key]
      if (!value) {
        return true
      }
      var stored = (this.user && this.user[key] !== null && this.user[key] !== undefined) ? String(this.user[key]) : ''
      if (value === stored) {
        return true
      }
      var tel = /^0\d{1,4}-\d{1,4}-\d{3,4}$/
      var digits = /^0\d{9,10}$/
      return tel.test(value) || digits.test(value)
    },
    // 本人情報を訂正して保存する（本人入力と同じ users の列に入る）
    saveProfile: function () {
      if (this.profileSaving) {
        return
      }
      for (var i = 0; i < this.profileFields.length; i++) {
        if (this.profileFields[i].type === 'tel' && !this.isTelValid(this.profileFields[i].key)) {
          window.alert(this.$t('validations.fomat_tel'))
          return
        }
        if (this.profileFields[i].type === 'month' && !this.isMonthValid(this.profileFields[i].key)) {
          window.alert(this.$t('onboarding.message.month_format'))
          return
        }
      }
      var self = this
      this.profileSaving = true
      this.$store.dispatch('UPDATE_ONBOARDING_USER_PROFILE', {
        id: this.$route.params.id,
        data: this.profileForm,
        callback: function () {
          self.profileSaving = false
          self.profileEditing = false
          self.search()
        }
      })
      .then(() => { self.profileSaving = false })
      .catch(() => { self.profileSaving = false })
    },
    // 仮登録で選んだシフト区分を変える（保存してから「労働条件通知書を作成」で作り直す）
    saveContractShiftClasses: function () {
      var self = this
      this.$store.dispatch('UPDATE_ONBOARDING_USER_PROFILE', {
        id: this.$route.params.id,
        data: {contract_shift_class_ids: this.contractShiftClassIds.join(',')},
        callback: function () { self.search() }
      })
    },
    fileUrl: function (document) {
      return document.file_url + '?token=' + this.authToken
    },
    statusClass: function (status) {
      if (status === 'submitted') return 'label-warning'
      if (status === 'approved') return 'label-success'
      if (status === 'rejected') return 'label-danger'
      return 'label-default'
    },
    // 最新の提出回次
    latestSubmission: function (document) {
      return (document.submissions && document.submissions.length > 0) ? document.submissions[0] : null
    },
    // 未提出（提出も「なし」申告も無い書類種別。API は必須書類の全種別を返す）
    isNotSubmitted: function (document) {
      return !this.latestSubmission(document) && !document.not_applicable
    },
    // 本登録の必須でない項目（免許証・任意保険証・車検証。API の register_checks.items[].required が false）
    // 旧 API（required が無い）では必須扱い
    isOptionalItem: function (item) {
      return item.required === false
    },
    // 過去の提出回次（折りたたみ表示）
    pastSubmissions: function (document) {
      return (document.submissions && document.submissions.length > 1) ? document.submissions.slice(1) : []
    },
    isHistoryOpened: function (documentType) {
      return this.openedHistories[documentType] === true
    },
    toggleHistory: function (documentType) {
      this.$set(this.openedHistories, documentType, !this.openedHistories[documentType])
    },
    // 書類種別（最新の提出回次）をまとめて承認する
    approve: function (documentType) {
      if (!window.confirm(this.$t('onboarding.message.approve_confirm'))) {
        return
      }
      var self = this
      this.$store.dispatch('APPROVE_ONBOARDING_SUBMISSION', {
        userId: this.$route.params.id,
        documentType: documentType,
        callback: function () { self.search() }
      })
    },
    // 書類種別（最新の提出回次）をまとめて差し戻す
    reject: function (documentType) {
      var comment = this.reviewComments[documentType]
      if (!comment || comment.trim() === '') {
        window.alert(this.$t('onboarding.message.comment_required'))
        return
      }
      if (!window.confirm(this.$t('onboarding.message.reject_confirm'))) {
        return
      }
      var self = this
      this.$store.dispatch('REJECT_ONBOARDING_SUBMISSION', {
        userId: this.$route.params.id,
        documentType: documentType,
        data: {review_comment: comment},
        callback: function () { self.search() }
      })
    },
    resendInvitation: function () {
      var self = this
      this.$store.dispatch('RESEND_ONBOARDING_INVITATION', {id: this.$route.params.id, callback: function () { self.search() }})
    },
    createContract: function () {
      var self = this
      this.$store.dispatch('CREATE_EMPLOYMENT_CONTRACT', {
        id: this.$route.params.id,
        data: {employment_pattern: this.employmentPattern},
        callback: function () { self.search() }
      })
    },
    showMyNumber: function () {
      if (!window.confirm(this.$t('onboarding.message.my_number_confirm'))) {
        return
      }
      this.$store.dispatch('GET_MY_NUMBER', {id: this.$route.params.id})
    },
    // 【本登録】: 入社手続きを完了にする（本登録・完了メール）。承認とは別に最後に押す
    // 事前チェックに不足があるときは、人事管理責任者・システム管理者のみ強制登録（force: true）できる
    register: function () {
      if (this.registering || !this.canPressRegister) {
        return
      }
      var force = !this.registerReady
      var confirmMessage = force
        ? this.$t('onboarding.message.force_registration_confirm')
        : this.$t('onboarding.message.registration_confirm')
      if (!window.confirm(confirmMessage)) {
        return
      }
      var self = this
      this.registering = true
      this.$store.dispatch('REGISTER_ONBOARDING_USER', {
        id: this.$route.params.id,
        data: force ? {force: true} : {},
        callback: function () {
          self.registering = false
          self.search()
        }
      })
      .then(() => { self.registering = false })
      .catch(() => { self.registering = false })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/onboarding-detail.js